<template>
  <div class="mapSwiper">
    <div class="title">
      <img src="@/assets/reservation/tiele03.png" alt="" />
    </div>
    <div class="sceneSwiper">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in siwperData"
          :key="index"
        >
          <img :src="item.img" class="img" alt="" />
        </div>
      </div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
      <div class="swiper-pagination"></div>
    </div>

    <Footer v-if="clientWidth <= 768" />
  </div>
</template>
<script>
import Footer from "../components/Footer.vue";
import Swiper from "swiper/swiper-bundle.min.js";
import "swiper/swiper-bundle.min.css";
export default {
  components: {
    Footer,
  },
  data() {
    return {
      siwperData: [
        {
          img: require("@/assets/reservation/p1.png"),
        },
        {
          img: require("@/assets/reservation/p2.png"),
        },
        {
          img: require("@/assets/reservation/p3.png"),
        },
        {
          img: require("@/assets/reservation/p4.png"),
        },
        {
          img: require("@/assets/reservation/p5.png"),
        },
      ],
      clientWidth: document.body.clientWidth,
    };
  },
  mounted() {
    this.initSwiper();
    window.addEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.clientWidth = document.body.clientWidth;
      this.initSwiper();
    },
    initSwiper() {
      let that = this;
      new Swiper(".sceneSwiper", {
        watchSlidesProgress: true,
        slidesPerView: that.clientWidth > 900 ? 3 : 1.2,
        centeredSlides: true,
        loop: true,
        loopedSlides: 5,
        autoplay: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          progress: function () {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              var slideProgress = this.slides[i].progress;
              var modify = 1;
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
              }
              var translate =
                slideProgress * modify * (that.clientWidth > 900 ? 260 : 110) +
                "px";
              var scale = 1 - Math.abs(slideProgress) / 5;
              var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
              slide.transform(
                "translateX(" + translate + ") scale(" + scale + ")"
              );
              slide.css("zIndex", zIndex);
              slide.css("opacity", 1);
              if (Math.abs(slideProgress) > 1.5) {
                slide.css("opacity", 0);
              }
            }
          },
          setTransition: function (swiper, transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              slide.transition(transition);
            }
          },
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.mapSwiper {
  width: 100%;
  height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url("~@/assets/reservation/bg_03.jpg");
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  // padding-top: 8%;
  overflow: hidden;
  position: relative;
  .footer {
    background: none;
  }
  @media only screen and (max-width: 768px) {
    justify-content: space-between;
  }
  @media only screen and (max-width: 900px) {
    padding: 20% 0;
  }
  .title {
    text-align: center;
    img {
      // width: 19vw;
      max-width: 91.6rem;
      height: auto;
      width: 100%;
    }
    @media only screen and (max-width: 768px) {
      margin-bottom: 10%;
    }
  }
  .manBox {
    position: absolute;
    text-align: center;
    bottom: 0;
    img {
      width: 80%;
      display: block;
      margin: 0 auto;
    }
  }
}
.sceneSwiper {
  margin-top: 41px;
  position: relative;
  @media only screen and (max-width: 900px) {
    margin: 0;
    position: relative;
  }
  .swiper-slide {
    &.swiper-slide-prev,
    &.swiper-slide-next {
      opacity: 0.73 !important;
    }
  }

  .swiper-pagination {
    bottom: -3.6rem;
    ::v-deep .swiper-pagination-bullet {
      width: 2.3rem;
      height: 1rem;
      background: #392c1c;
      margin: 0 0.75rem;
      opacity: 1;
      border-radius: 0;
      &.swiper-pagination-bullet-active {
        width: 4.8rem;
        background: #99784f;
      }
    }
    @media only screen and (max-width: 900px) {
      ::v-deep .swiper-pagination-bullet {
        width: 1.6rem;
        height: 0.7rem;
        margin: 0 0.55rem;
        &.swiper-pagination-bullet-active {
          width: 3.4rem;
        }
      }
    }
  }
}

::v-deep.swiper-slide {
  img {
    width: 100%;
  }
}
::v-deep.swiper-button-prev {
  left: 18%;
  background-image: url("~@/assets/reservation/arrow-l.png");
  background-size: contain;
  background-repeat: no-repeat;
  width: 100px;
  height: 100px;
  @media only screen and (max-width: 900px) {
    width: 4.7rem;
    height: 2rem;
    left: 5%;
  }
}
::v-deep.swiper-button-prev::after {
  content: "";
}
::v-deep.swiper-button-next {
  right: 18%;
  background-image: url("~@/assets/reservation/arrow-r.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 100px;
  height: 100px;
  @media only screen and (max-width: 900px) {
    width: 4.7rem;
    height: 2rem;
    right: 5%;
  }
}
::v-deep.swiper-button-next::after {
  content: "";
}
</style>
